import { getAllPortals, isAIPreisschilder } from '../_tools/Session';
import { getElementFromArray } from '../_tools/Texte';
import { checkUndefinedNullOrEmpty, checkUndefinedOrNull, neededTableColumnDefinitionForUserSettings } from '../_tools/Tools';
import { type Vertrage } from '../_tools/Vertrag';
import { type DataGridEnrichedColDef, type DataGridProps } from '../_tools/datagrid/types';
import { type CustomTheme } from '../provider/ThemeProvider';
import sSpaltenFahrzeugliste from './s_spaltenFahrzeugliste';

const sNewStandardTableLayouts = (tableMode: string | number, theme: CustomTheme, vertrage: Vertrage): DataGridProps['columns'] => {
    const portals = getAllPortals().map((portal) => 'export.' + portal + '.exp');
    const cols = {
        // Standard
        0: ['urThumb', 'nr', 'st', 'tp', 'hs', 'md', 'stat.st2', 'warnings', isAIPreisschilder() ? 'aip' : undefined, 'export.exp', 'isRes', 'pr.bvkd'],
        // Effizienz
        1: [
            'urThumb',
            'nr',
            'hs',
            'md',
            'vb.iks',
            'consumptions.w_cfc',
            'consumptions.w_cfl',
            'consumptions.w_cfm',
            'consumptions.w_cfh',
            'consumptions.w_cfeh',
            'consumptions.w_co2ec',
            'consumptions.co2class',
            'vb.isn',
            'vb.ipl',
            'pr.jst',
        ],
        // Finanzierung
        2: [
            'urThumb',
            'nr',
            'hs',
            'md',
            'fd.fin.lz',
            'fd.fin.km',
            'fd.fin.mr',
            'fd.fin.az',
            'fd.fin.sr',
            'fd.fin.ez',
            'fd.fin.sz',
            'fd.fin.iksb',
            'fd.fin.ksbbd',
            'fd.fin.ndb',
            'fd.fin.gb',
            'fd.fin.bank',
            'fd.fin.comment',
            'fd.fin.up',
            'pr.bvkd',
        ],
        // Fahrzeugexport
        3: ['nr', 'hs', 'md', 'export.exp', 'pr.bvkd'],
        // mobile.de
        4: ['urThumb', 'nr', 'hs', 'md', 'stat.st2', 'mobileTopinserat', 'mobileBlickfang', 'mobileSeiteEins', 'mobileRotstiftpreis', 'mobileAdTurbo', 'mobileEbayKleinanzeigen'],
        // Leads
        5: ['urThumb', 'nr', 'hs', 'md', 'stat.st2', 'export.exp', 'isRes', 'leads.offenAmount', 'leads.beendetAmount', 'pr.bvkd'],
        // Verkauft
        6: ['urThumb', 'nr', 'tp', 'hs', 'md', 'stat.st2', 'usr_v.n', 'pr.bvkd', 'pr.berg'],
        // Standzeit Eins
        7: [
            'nr',
            'ch',
            'st',
            'herk',
            'hs',
            'md',
            'se.i',
            'so',
            'usr_e.n',
            'stat.sw',
            'stat.zr',
            'stat.ec',
            'stat.tuv',
            'stat.tuvok',
            'stat.wv',
            'stat.wvok',
            'stat.w',
            'stat.wok',
            'stat.we',
            'stat.weok',
            'stat.l',
            'stat.lok',
            'stat.a',
            'stat.aok',
            'stat.vkf',
        ],
        // Fahrzeugexport NEU
        8: ['nr', 'hs', 'md', 'export.exp', ...portals, 'pr.bvkd'],
        // TrackingOld
        9: ['nr', 'hs', 'md', 'export.exp', 'tracking.pos.impressions', 'tracking.pos.parkings', 'tracking.pos.pos', 'pr.bvkd'],
        // Tracking
        10: [
            'nr',
            'hs',
            'md',
            'export.exp',
            'stat.st2',
            'stat.pt',
            'tracking.pos.pos',
            'tracking.pos.impressions',
            'tracking.pos.parkings',
            'tracking.pos.calls',
            'tracking.pos.prints',
            'tracking.pos.mails',
            'pr.bvkd',
        ],
    };

    const returnArray = [];

    const oldCols: DataGridProps['columns'] = sSpaltenFahrzeugliste(theme, vertrage);
    cols[tableMode]
        .filter((key) => !checkUndefinedNullOrEmpty(key))
        .map((key, i) => {
            const colOriginal = getElementFromArray<DataGridEnrichedColDef>(oldCols, key, 'field', undefined);
            if (!checkUndefinedNullOrEmpty(colOriginal)) {
                const newCol: DataGridEnrichedColDef = { headerName: colOriginal.headerName, field: colOriginal.field, order: i };
                neededTableColumnDefinitionForUserSettings(true).map((f) => {
                    newCol[f.id] = !checkUndefinedOrNull(colOriginal[f.id]) ? colOriginal[f.id] : f.default === 'index' ? i : f.default;
                });
                returnArray.push(newCol);
            }
        });

    return returnArray;
};
export default sNewStandardTableLayouts;
